/**
 * Company Status Constants
 *
 * Canonical value set for `companies.status` (text column in Postgres — not a
 * PG enum). Keep in sync with Hub UI `COMPANY_STATUS_OPTIONS` and live data.
 * Use `z.enum(COMPANY_STATUS_VALUES)` for Meridian/MCP tools — never a
 * hand-typed subset (list_companies previously exposed only active/inactive/
 * prospect and silently hid client / former_client / suspended).
 */

export const COMPANY_STATUS_VALUES = [
  "active",
  "inactive",
  "prospect",
  "client",
  "former_client",
  "suspended",
] as const;

export type CompanyStatus = (typeof COMPANY_STATUS_VALUES)[number];
